import Api from '@/classes/Api.ts';
import { ApiRequestParams } from '@/types/api.type.ts';

class DocumentDownloader
{
    private $Api: Api;

    constructor($Api: Api) {
        this.$Api = $Api;
    }

    public getData(endpointName: string, params: ApiRequestParams): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.$Api.callNew(endpointName, params, { responseType: 'blob' })
                .then(({ data }: any) => {
                    resolve(data);
                })
                .catch(reject);
        });
    }

    public download(endpointName: string, params: ApiRequestParams, name: string): Promise<void>
    {
        return new Promise((resolve, reject) => {
            this.getData(endpointName, params)
                .then((data: any) => {
                    resolve();
                    this.downloadData(data, name);
                })
                .catch(reject);
        });
    }

    public downloadData(data: any, name: string): void
    {
        const href = URL.createObjectURL(data);

        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }
}

export default DocumentDownloader;
